
import { objAny } from "@/common/common-interface";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class PiStatisticsItemComponents extends Vue {
  @Prop({ default: "" }) private name!: string; //标题
  @Prop({ default: "" }) private bgColor!: string; // 背景色
  @Prop({ default: 0 }) private value!: number; // 值
  @Prop({ default: true }) private content!: boolean; // 是否有内容
  @Prop({ default: true }) private valueShow!: boolean; // 是否显示值 value
  @Prop({ default: true }) private nameShow!: boolean; // 是否显示标题
  @Prop({
    default: () => {
      return [];
    }
  })
  private valueList!: objAny[]; // 多个数据
  @Prop({
    default: () => {
      return [];
    }
  })
  private childList!: objAny[]; // 一个总参数下还有多个数据

  public itemClick(): void {
    this.$emit("click");
  }

  get getItemClassName(): string {
    let className = this.bgColor;
    if (this.childList && this.childList.length > 0) {
      className += " child-show";
    }
    return className;
  }
}
